/**
 * Gets the label for a filter type
 * @param {string} type - Filter type value
 * @param {Array} filterTypes - Array of filter type definitions from component
 * @returns {string} - Filter type label
 */
export const getFilterTypeLabel = (type, filterTypes = []) => {
  if (filterTypes && filterTypes.length > 0) {
    const filterType = filterTypes.find((t) => t.value === type);
    if (filterType?.label) return filterType.label;
  }
  return type;
};

/**
 * Gets the display label for a filter value
 * Looks up the label from filterValues if available, otherwise formats the raw value
 * @param {string|string[]} value - Filter value(s)
 * @param {string} filterType - The filter type
 * @param {Object} filterValues - Object mapping filter types to their options
 * @returns {string} - The formatted label(s)
 */
export const getFilterValueLabel = (value, filterType, filterValues = {}) => {
  const options = filterValues?.[filterType];
  
  // Handle array values (multi-select)
  if (Array.isArray(value)) {
    if (value.length === 0) return '';
    
    const labels = value.map((v) => {
      const option = options?.find((opt) => opt.value === v || opt.value === String(v));
      return option?.label || v;
    });
    
    if (labels.length === 1) return labels[0];
    if (labels.length <= 2) return labels.join(', ');
    return `${labels.slice(0, 2).join(', ')} +${labels.length - 2}`;
  }
  
  // Handle single value
  const option = options?.find((opt) => opt.value === value || opt.value === String(value));
  return option?.label || value || '';
};

